<div class="team-page">
  <div class="page-header">
    <h1>I tuoi eventi</h1>
    <p class="page-subtitle">Gli eventi a cui sei assegnato</p>
  </div>

  <div class="loading" *ngIf="loading">Caricamento...</div>

  <app-load-error *ngIf="!loading && loadError" (retry)="load()"></app-load-error>

  <div class="empty" *ngIf="!loading && !loadError && events.length === 0">
    <span class="empty-icon">✦</span>
    <p>Nessun evento assegnato al momento.</p>
  </div>

  <div class="events-list" *ngIf="!loading && events.length > 0">
    <div
      class="event-card"
      *ngFor="let e of events"
      [class.past]="isPast(e.event?.date)"
      (click)="openEvent(e._id)"
    >
      <div class="event-date-col">
        <span class="event-day">{{ dayOf(e.event?.date) }}</span>
        <span class="event-month">{{ monthOf(e.event?.date) }}</span>
        <span class="event-year">{{ yearOf(e.event?.date) }}</span>
      </div>
      <div class="event-info">
        <p class="event-client">{{ e.client?.name }} {{ e.client?.lastname }}</p>
        <p class="event-location" *ngIf="e.event?.location">
          {{ e.event?.location }}
        </p>
        <p class="event-time" *ngIf="e.event?.time">Ore {{ e.event?.time }}</p>
      </div>
      <span class="event-arrow">›</span>
    </div>
  </div>
</div>
